import styles from './Photo.module.css';
// import ice from '../../assets/images/ice.jpg';
// import { useProgressAnimation } from '../../hooks/useProgressAnimation';

export const Photo = ({ message, rotateSign, speedSlow }) => {
  // const progress = useProgressAnimation({ speedSlow });

  // Рассчитываем радиус маски
  // const maskRadius = progress * 1000;

  return (
    <div
      style={{
        '--angle': `${rotateSign}5deg`,
        transform: `rotate(${rotateSign}5deg)`,
      }}
      className={styles.photo}
      key={message.id}
    >
      <img
        src={message?.attachments[0].url}
        alt={''}
        className={styles.attach}
      />

      {/* SVG маска */}
      {/* <svg
        width="100%"
        height="100%"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          pointerEvents: 'none',
        }}
      >
        <defs>

          <pattern
            id="imagePattern"
            patternUnits="userSpaceOnUse"
            width="100%"
            height="100%"
          >
            <image
              href={ice}
              width="calc(100% - 0.5rem)"
              height="calc(100% - 0.5rem)"
              preserveAspectRatio="xMidYMid slice"
            />
          </pattern>

          <mask id="circleMask">
     
            <rect width="100%" height="100%" fill="white" />
    
            <circle
              cx="50%"
              cy="50%"
              r={maskRadius}
              fill="url(#gradientMask)"
            />
          </mask>

          <radialGradient id="gradientMask" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="black" stopOpacity="1" />
            <stop offset="70%" stopColor="black" stopOpacity="1" />
            <stop offset="100%" stopColor="white" stopOpacity="1" />
          </radialGradient>
        </defs>


        <rect
          width="100%"
          height="100%"
          fill="url(#imagePattern)"
          mask="url(#circleMask)"
          opacity="0.9"
        />
      </svg> */}
    </div>
  );
};
